import { TagInput } from '@/design-system/taginput';
import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import type { Tag } from 'react-tag-input';
import { FormField } from './Field';
import { useFormField } from './hooks';
import type { UseFormFieldProps } from './type';

interface FormTagInputProps
  extends Omit<React.ComponentProps<typeof TagInput>, 'value' | 'onValueChange'>,
    UseFormFieldProps {
  name: string;
  initialValue?: Tag[];
}

export function FormTagInput(props: FormTagInputProps) {
  const { control, clearErrors, setError } = useFormContext();
  const { formFieldProps, childProps } = useFormField(props);
  const {
    name,
    initialValue,
    placeholder,
    maxTags,
    className,
    tagClassName,
    tagInputFieldClassName,
    removeClassName,
    tagRegex,
  } = props;

  const { field } = useController({
    name,
    control,
  });

  const value = (field.value ?? []) as Tag[];

  const handleValueChange = (next: Tag[]) => {
    clearErrors(name);
    field.onChange(next);
  };

  const handleInvalidValue = () => {
    setError(name, { type: 'validate', message: 'common.form.validation.nameOnly' });
  };

  return (
    <FormField {...formFieldProps}>
      <TagInput
        {...childProps}
        value={value}
        onValueChange={handleValueChange}
        onInvalidValue={handleInvalidValue}
        initialValue={initialValue}
        placeholder={placeholder}
        maxTags={maxTags}
        className={className}
        tagClassName={tagClassName}
        tagInputFieldClassName={tagInputFieldClassName}
        removeClassName={removeClassName}
        tagRegex={tagRegex}
      />
    </FormField>
  );
}
